import "@/App.css";
import Presentation from "@/Presentation";

function App() {
  return <Presentation />;
}

export default App;
